/**
 * The scope of consolidation.
 *
 * Everything this kind is: how it is made, how it is read back, what it looks
 * like on the page, and how it is edited. Nothing outside this folder needs to
 * know the kind exists.
 */

import { readArray, readString } from '@/domain/json'
import type { JsonValue } from '@/domain/json'
import { newId, newScopeEntry, type ScopeEntry, type ScopeSection } from '@/domain/section'
import ScopeBlock from '@/sections/scope/ScopeBlock.vue'
import ScopeInspector from '@/sections/scope/ScopeInspector.vue'
import type { SectionDefinition } from '@/sections/types'

function readScopeEntry(value: JsonValue): ScopeEntry {
  return {
    id: readString(value, 'id') || newId(),
    entity: readString(value, 'entity'),
    country: readString(value, 'country'),
    method: readString(value, 'method'),
    controlPct: readString(value, 'controlPct'),
    interestPct: readString(value, 'interestPct'),
  }
}

export const scopeSection: SectionDefinition<'scope', ScopeSection> = {
  kind: 'scope',
  band: 'annex',

  icon: [
    'M6 2.5h4v2.5h-4z',
    'M2 11h3.5v2.5H2z',
    'M10.5 11H14v2.5h-3.5z',
    'M8 5v3.5',
    'M3.75 11V8.5h8.5V11',
  ],

  create: (id, title) => ({
    id,
    kind: 'scope',
    title,
    entries: [newScopeEntry()],
    caption: '',
  }),

  read: ({ id, title, stored }) => ({
    id,
    kind: 'scope',
    title,
    entries: readArray(stored, 'entries').map(readScopeEntry),
    caption: readString(stored, 'caption'),
  }),

  block: ScopeBlock,
  inspector: ScopeInspector,
}
